// extracted by mini-css-extract-plugin
module.exports = {"head":"FormCard_head__UiDvy","title":"FormCard_title__osXVi","description":"FormCard_description__LOe4g","buttons":"FormCard_buttons__UVBEL","rotation":"FormCard_rotation__PkjwR"};